import AdultFront from '../../../../../assets/images/bodyMaps/AdultFront.jpg'
import AdultBack from '../../../../../assets/images/bodyMaps/AdultBack.jpg'
import BabyBack from '../../../../../assets/images/bodyMaps/BabyBack.jpg'
import BabyFront from '../../../../../assets/images/bodyMaps/BabyFront.jpg'
import BabyLeft from '../../../../../assets/images/bodyMaps/BabyLeft.jpg'
import BabyRight from '../../../../../assets/images/bodyMaps/BabyRight.jpg'
import ChildBack from '../../../../../assets/images/bodyMaps/ChildBack.jpg'
import ChildFront from '../../../../../assets/images/bodyMaps/ChildFront.jpg'
import EarLeft from '../../../../../assets/images/bodyMaps/EarLeft.jpg'
import EarRight from '../../../../../assets/images/bodyMaps/EarRight.jpg'
import FaceSet from '../../../../../assets/images/bodyMaps/FaceSet.jpg'
import FootLeft from '../../../../../assets/images/bodyMaps/FootLeft.jpg'
import FootRight from '../../../../../assets/images/bodyMaps/FootRight.jpg'
import HandLeft from '../../../../../assets/images/bodyMaps/HandLeft.jpg'
import HandRight from '../../../../../assets/images/bodyMaps/HandRight.jpg'
import HeadFront from '../../../../../assets/images/bodyMaps/HeadFront.jpg'
import HeadLeft from '../../../../../assets/images/bodyMaps/HeadLeft.jpg'
import HeadRight from '../../../../../assets/images/bodyMaps/HeadRight.jpg'
import HeadTop from '../../../../../assets/images/bodyMaps/HeadTop.jpg'

const getMedicalDrawingCanvas = (selected) => {
    switch (selected) {
        case 'Adult Front':
            return AdultFront
        case 'Adult Back':
            return AdultBack
        case 'Baby Back':
            return BabyBack
        case 'Baby Front':
            return BabyFront
        case 'Baby Left':
            return BabyLeft
        case 'Baby Right':
            return BabyRight
        case 'Child Back':
            return ChildBack
        case 'Child Front':
            return ChildFront
        case 'Ear Left':
            return EarLeft
        case 'Ear Right':
            return EarRight
        case 'Face':
            return FaceSet
        case 'Foot Left':
            return FootLeft
        case 'Foot Right':
            return FootRight
        case 'Hand Left':
            return HandLeft
        case 'Hand Right':
            return HandRight
        case 'Head Front':
            return HeadFront
        case 'Head Left':
            return HeadLeft
        case 'Head Right':
            return HeadRight
        case 'Head Top':
            return HeadTop
    }
}

export default getMedicalDrawingCanvas